import { render, staticRenderFns } from "./acaoForm.vue?vue&type=template&id=d21387a4&scoped=true&"
var script = {}
import style0 from "./acaoForm.vue?vue&type=style&index=0&id=d21387a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21387a4",
  null
  
)

export default component.exports